export default __webpack_public_path__ + "static/media/img_cool_0.2f66cd44.png";